<template>
  <div :class="s.wrapper">
    <div :class="s.title">利用規約</div>
    <div :class="s.description" v-html="terms.description" />
    <section v-for="(section, i) in terms.contents" :key="i">
      <div :class="s.section_title">
        <span v-html="i + 1" />.
        <span v-html="section.title" />
      </div>
      <div :class="s.section_content">
        <div :class="s.section_description" v-html="section.description" />
        <!-- 括弧のリスト -->
        <ul
          :class="s.list_bracket"
          v-if="section.type === 'list-bracket'">
          <li v-for="(bracketItem, j) in section.contents" :key="j">
            <div :class="s.list_bracket_title">
              <span>{{ `(${j + 1}) ` }}</span>
              <span v-html="bracketItem.title"/>
            </div>
            <ul :class="s.list">
              <li v-for="(item, k) in bracketItem.contents" :key="k">{{ item }}</li>
            </ul>
            <div :class="s.note" v-html="bracketItem.note"/>
          </li>
        </ul>
        <!-- リスト -->
        <ul v-else-if="section.type === 'list'" :class="s.list">
          <li v-for="(item, j) in section.contents" :key="j" v-html="item" />
        </ul>
        <div v-else v-html="section.contents" />
      </div>
    </section>
  </div>
</template>

<script>
import terms from '@/data/terms.yaml';

export default {
  data() {
    return {
      terms,
    };
  },
};
</script>

<style lang="scss" module="s">
.wrapper {
  padding: calc(var(--header-height) + 24px) 24px 24px;
  max-width: 800px;
  margin: 0 auto;
  @include mdView {
    padding-top: calc(var(--md-header-height) + 24px);
  }
}
.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 32px;
}
.section_title {
  font-weight: bold;
  margin-bottom: 8px;
}
.section_description {
  margin-bottom: 8px;
}
.section_content {
  padding-left: 16px;
}
.list_bracket {
  > li {
    &:not(:first-child) {
      margin-top: 8px;
    }
  }
  &_title {
    font-weight: bold;
  }
}
.list {
  margin-top: 4px;
  > li {
    padding-left: 24px;
    position: relative;
    &::before {
      content: '';
      width: 5px;
      height: 5px;
      border-radius: 10px;
      background-color: var(--label-primary);
      position: absolute;
      left: 5px; top: 50%;
      transform: translateY(-50%);
    }
  }
}
.note {
  margin-top: 4px;
}
</style>

<style lang="scss" scoped>
section {
  margin-top: 32px;
}
</style>

<style lang="scss">
.policy_form_link {
  margin-top: 8px;
  display: inline-block;
  // text-decoration: underline;
  border-radius: 6px;
  padding: 12px 24px;
  background-color: var(--theme-blue);
  color: #ffffff;
}
</style>
